import React from "react";
import { useNavigate } from "react-router-dom";

import imgValoracionDisfagia from "../images/valoracion-disfagia.png";
import imgValoracionNutricional from "../images/valoracion-nutricional.png";
import imgRecomendaciones from "../images/recomendaciones.png";
import imgRecetas from "../images/recetas.png";
import imgActividadEjercicioFisico from "../images/actividad-ejercicio-fisico.png";
import imgPautasEjerciciosLogopediaRehabilitacion from "../images/pautas-ejercicios-logopedia-y-rehabilitación.png";
import imgDisfagiaFarmacos from "../images/disfagia-y-farmacos.png";
import imgFAQs from "../images/faqs.png";

export default function Contenido() {
  const navigate = useNavigate();

  const items = [
    { src: imgValoracionDisfagia, alt: "Valoración disfagia", path: "/valoracion-disfagia" },
    { src: imgValoracionNutricional, alt: "Valoración nutricional", path: "/valoracion-nutricional" },
    { src: imgRecomendaciones, alt: "Recomendaciones", path: "/recomendaciones" },
    { src: imgRecetas, alt: "Recetas", path: "/recetas" },
    { src: imgActividadEjercicioFisico, alt: "Actividad / Ejercicio físico", path: "/ejercicios" },
    { src: imgPautasEjerciciosLogopediaRehabilitacion, alt: "Pautas / Ejercicios de logopedia y rehabilitación", path: "/pautas-ejercicios-logopedia-rehabilitacion" },
    { src: imgDisfagiaFarmacos, alt: "Disfagia y fármacos", path: "/disfagia-y-farmacos" },
    { src: imgFAQs, alt: "FAQs", path: "/faqs" },
  ];

  return (
    <div className="px-4 max-w-6xl mx-auto mt-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 place-items-center">
        {items.map(({ src, alt, path }) => (
          <div
            key={path}
            onClick={() => navigate(path)}
            className="
              aspect-square
              w-32 sm:w-48 lg:w-56 xl:w-60
              bg-white
              rounded-2xl
              shadow
              cursor-pointer
              flex flex-col items-center justify-center
              p-3 sm:p-5 lg:p-6
              hover:scale-105 transition-transform duration-200
            "
          >
            <img
              src={src}
              alt={alt}
              className="max-h-full max-w-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
}